import React from 'react';
import {useTranslation} from 'react-i18next';

import styles from './modal-base.module.css';

const TicketsModal = () => {
  const {t} = useTranslation();

  return (
    <>
      <h3 className={styles.modalTitle}>
        {t('fifa2022.useFullMaterialsWidget.tickets.modal.title')}
      </h3>
      <p className={styles.modalText}>
        {t('fifa2022.useFullMaterialsWidget.tickets.modal.text1Start')}
        <a
          href="https://www.fifa.com/fifaplus/en/tickets"
          target="_blank"
          className={styles.modalTextLink}
          rel="noreferrer"
        >
          {t('fifa2022.useFullMaterialsWidget.tickets.modal.text1Link')}
        </a>
        {t('fifa2022.useFullMaterialsWidget.tickets.modal.text1End')}
      </p>
      <p className={styles.modalText}>
        {t('fifa2022.useFullMaterialsWidget.tickets.modal.text2')}
      </p>
      <p className={styles.modalText}>
        {t('fifa2022.useFullMaterialsWidget.tickets.modal.text3')}
        <a
          href="https://www.qatar2022.qa"
          target="_blank"
          className={styles.modalTextLink}
          rel="noreferrer"
        >
          {t('fifa2022.useFullMaterialsWidget.tickets.modal.text3Link')}
        </a>.
      </p>
      <a
        className={styles.modalLink}
        href="https://www.fifa.com/fifaplus/en/tickets"
        target="_blank"
        rel="noreferrer"
      >
        {t('fifa2022.useFullMaterialsWidget.tickets.modal.buttonText1')}
      </a>
      <a
        className={styles.modalLink}
        href="https://hayya.qatar2022.qa/"
        target="_blank"
        rel="noreferrer"
      >
        {t('fifa2022.useFullMaterialsWidget.tickets.modal.buttonText2')}
      </a>
    </>
  );
};

export default TicketsModal;

